import {
  topBarBreadcrumbsClasses,
  topBarClasses,
  topBarSlotClasses,
} from '@/shared/layout/top-bar/styles';
import type { TopBarProps } from '@/shared/layout/top-bar/types';

export function useTopBarProps({
  navigationSlot,
  breadcrumbs,
  tenantSlot,
  actionsSlot,
  profileSlot,
}: TopBarProps) {
  return {
    rootProps: { className: topBarClasses },
    breadcrumbsProps: { className: topBarBreadcrumbsClasses },
    breadcrumbs,
    slotProps: { className: topBarSlotClasses },
    navigationSlot,
    tenantSlot,
    actionsSlot,
    profileSlot,
  };
}
